export class CommonHelper {
    public static clone(oObjectToClone) {
        return JSON.parse(JSON.stringify(oObjectToClone));
    }
}